(function () {
  const config = window.deciselyPayrollModal || null;

  let currentEntryId = null;
  let currentUrls = null;
  let currentParams = null;
  let modalInitialized = false;
  let modalOpenedForCurrentConfirmation = false;

  function getTriggerData() {
    const trigger = document.querySelector("#decisely-payroll-modal-trigger");
    if (!trigger) return null;

    return {
      entryId: trigger.dataset.entryId,
      genericUrl: trigger.dataset.genericUrl,
      adpUrl: trigger.dataset.adpUrl,
      paycomUrl: trigger.dataset.paycomUrl,
      hasPaycomPage: trigger.dataset.hasPaycomPage === "1",
      first: trigger.dataset.first || "",
      last: trigger.dataset.last || "",
      company: trigger.dataset.company || "",
      email: trigger.dataset.email || "",
      modalHeading: trigger.dataset.modalHeading || "",
      modalQuestion: trigger.dataset.modalQuestion || "",
      modalText: trigger.dataset.modalText || "",
    };
  }

  function getRedirectUrl(provider, urls) {
    if (provider === "ADP") return urls.adpUrl;
    if (provider === "Paycom") return urls.paycomUrl;
    return urls.genericUrl;
  }

  function buildRedirectUrl(url, entryId, params, provider) {
    const finalUrl = new URL(url, window.location.origin);

    finalUrl.searchParams.set("entry_id", entryId);

    if (params?.first) finalUrl.searchParams.set("first", params.first);
    if (params?.last) finalUrl.searchParams.set("last", params.last);
    if (params?.company) finalUrl.searchParams.set("company", params.company);
    if (params?.email) finalUrl.searchParams.set("email", params.email);
    if (provider) finalUrl.searchParams.set("payroll", provider);

    return finalUrl.toString();
  }

  function redirectTo(url, entryId, params, provider = "") {
    window.location.href = buildRedirectUrl(url, entryId, params, provider);
  }

  function savePayrollProvider(entryId, provider) {
    if (!config?.ajaxUrl || !config?.nonce) {
      return Promise.resolve(null);
    }

    return fetch(config.ajaxUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: new URLSearchParams({
        action: "decisely_save_payroll_provider",
        nonce: config.nonce,
        entry_id: entryId,
        provider: provider,
      }),
    }).then((response) => response.json());
  }

  function openPayrollModal() {
    const data = getTriggerData();
    if (!data) return;
    if (modalOpenedForCurrentConfirmation) return;

    currentEntryId = data.entryId;
    currentUrls = {
      genericUrl: data.genericUrl,
      adpUrl: data.adpUrl,
      paycomUrl: data.paycomUrl,
    };
    currentParams = {
      first: data.first,
      last: data.last,
      company: data.company,
      email: data.email,
    };

    const modalEl = document.getElementById("deciselyPayrollModal");
    if (!modalEl) return;
    if (typeof bootstrap === "undefined" || !bootstrap.Modal) return;

    const headingEl = modalEl.querySelector("#deciselyPayrollModalLabel");
    const questionEl = modalEl.querySelector(".decisely-payroll-modal-question");
    const textEl = modalEl.querySelector(".decisely-payroll-modal-text");
    const paycomBtn = modalEl.querySelector(".decisely-paycom-choice");

    if (headingEl && data.modalHeading) {
      headingEl.textContent = data.modalHeading;
    }

    if (questionEl && data.modalQuestion) {
      questionEl.textContent = data.modalQuestion;
    }

    if (textEl && data.modalText) {
      textEl.textContent = data.modalText;
    }

    if (paycomBtn) {
      paycomBtn.style.display = data.hasPaycomPage ? "" : "none";
    }

    const modal = bootstrap.Modal.getOrCreateInstance(modalEl, {
      backdrop: "static",
      keyboard: false,
    });

    modalOpenedForCurrentConfirmation = true;
    modal.show();
  }

  function bindModalEvents() {
    if (modalInitialized) return;

    const modalEl = document.getElementById("deciselyPayrollModal");
    if (!modalEl) return;

    modalEl.addEventListener("click", function (event) {
      const choiceBtn = event.target.closest(".decisely-payroll-choice");
      const skipBtn = event.target.closest(".decisely-payroll-skip");

      if (choiceBtn && currentEntryId && currentUrls) {
        const provider = choiceBtn.dataset.provider;
        const url = getRedirectUrl(provider, currentUrls);

        choiceBtn.disabled = true;

        savePayrollProvider(currentEntryId, provider)
          .catch(() => null)
          .finally(() => {
            redirectTo(url, currentEntryId, currentParams, provider);
          });

        return;
      }

      if (skipBtn && currentEntryId && currentUrls) {
        redirectTo(currentUrls.genericUrl, currentEntryId, currentParams, "");
      }
    });

    modalInitialized = true;
  }

  function watchForConfirmation() {
    if (window.jQuery) {
      window.jQuery(document).on("gform_confirmation_loaded", function () {
        modalOpenedForCurrentConfirmation = false;
        setTimeout(openPayrollModal, 50);
      });
    }

    const observer = new MutationObserver(() => {
      const trigger = document.querySelector("#decisely-payroll-modal-trigger");
      if (trigger) {
        openPayrollModal();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function boot() {
    bindModalEvents();
    watchForConfirmation();
    openPayrollModal();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();